import * as React from "react";
import { graphql, HeadProps, PageProps } from "gatsby";
import Layout from "../modules/layout";
import PageHeader from "../components/pageHeader";
import TimelineList from "../components/timelineList";
import { SeparationEnum } from "../components/pageHeader/PageHeader";
import pageAdaptors from "../adaptors/pageAdaptors/index";
import PageHead from "../components/pageHead";

const AboutUsPageTemplate = ({
  data,
}: PageProps<Queries.AboutUsPageTemplateQuery>) => {
  const pageData = pageAdaptors.adaptAboutUsPageTemplate({
    pageData: data.contentfulAboutUsPageTemplate,
    footer: data.contentfulFooter,
    navigationBar: data.contentfulNavigationBar,
  });

  return (
    <Layout
      browserTitle={pageData.browserTitle}
      footer={pageData.footer}
      navigationBar={pageData.navigationBar}
    >
      <PageHeader
        pageHeader={pageData.header!}
        separation={SeparationEnum.SLIM}
        borderBottom={false}
      />
      <TimelineList
        timeline={pageData.timeline}
        timelineName={pageData.timelineName}
      />
    </Layout>
  );
};

export const Head = ({ data }: HeadProps<Queries.AboutUsPageTemplateQuery>) => {
  const { browserTitle, title } = data.contentfulAboutUsPageTemplate!;

  return <PageHead browserTitle={browserTitle!} title={title?.title} />;
};

export const query = graphql`
  query AboutUsPageTemplate($id: String!) {
    contentfulNavigationBar(type: { eq: "GlobalNavigationBar" }) {
      primary {
        url
        label
      }
      secondary {
        url
        label
      }
    }
    contentfulFooter(type: { eq: "GlobalFooter" }) {
      links {
        url
        label
      }
    }
    contentfulAboutUsPageTemplate(id: { eq: $id }) {
      browserTitle
      url
      title {
        title
      }
      titleDescription {
        titleDescription
      }
      timelineName {
        raw
      }
      image {
        image {
          title
          description
          publicUrl
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      timeline {
        ... on ContentfulTimelineItem {
          __typename
          id
          itemDate
          image {
            image {
              title
              publicUrl
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          imagePosition
          itemDescription {
            raw
          }
        }
      }
    }
  }
`;

export default AboutUsPageTemplate;
